import { MODAL_OPEN, MODAL_CLOSE } from '../constants/Modal'

export function modalOpen() {
  return {
    type: MODAL_OPEN,
  }
}

export function modalClose() {
  return {
    type: MODAL_CLOSE,
  }
}



// WEBPACK FOOTER //
// ./src/actions/ModalActions.js